import type { ProcessingStage } from '../types/processing-stage';

/**
 * Mock processing pipeline shown in the upload panel. The stages mirror the
 * real staged-upload flow — mint a signed URL (/begin), PUT the bytes to
 * storage, then server-side Document Engine detection — so a viewer can tell
 * where they are. Durations are tuned to run on the order of a real
 * large-document upload+parse (~17s total) rather than finishing in seconds;
 * the panel snaps to "done" the moment the real upload actually completes.
 */
export const PROCESSING_STAGES: readonly ProcessingStage[] = [
  {
    id: 'upload',
    title: 'Preparing upload',
    durationMs: 1800,
    substage: 'Requesting a secure, encrypted upload link.',
    tech: 'POST /begin · signed URL',
  },
  {
    id: 'parse',
    title: 'Uploading document',
    durationMs: 4200,
    substage: 'Sending your file straight to secure storage.',
    tech: 'PUT signed URL · Supabase Storage',
  },
  {
    id: 'fields',
    title: 'Detecting fields',
    durationMs: 5000,
    substage:
      'Clai reads the pages and finds the text boxes, dates, initials and signatures you need to fill.',
    tech: 'Document Engine · field detection',
  },
  {
    id: 'signers',
    title: 'Identifying signers',
    durationMs: 3500,
    substage: 'Matching fields to the right parties — and their signing order.',
    tech: 'participant resolver · role heuristics',
  },
  {
    id: 'finalize',
    title: 'Finalizing',
    durationMs: 3000,
    substage: 'Saving the ClaiSchema and linking it to this deal.',
    tech: 'ClaiSchema saved',
  },
];
